<template>
  <vx-card :cardBorder="true" class="my-1" v-if="this.loaded">
    <validation-observer ref="productCategoryForm" v-slot="{ valid }" slim>
      <div class="w-full flex flex-wrap">
        <div>
          #{{ category.id }}
        </div>

        <validation-provider name="categoryName" rules="required" v-slot="{ errors, failed }" slim>
          <div class="flex flex-col mx-2">
            <bds-label :text="$t('lists.language.portuguese')" :mandatory="failed"/>
            <div class="flex flex-row">
              <i class="mr-2 flag-icon flag-icon-br"/>
              <vs-input size="small" class="md-base" v-model="category.ptBR.name" :disabled="!edit"/>
            </div>
            <bds-error :text_error="errors[0]"/>
          </div>
        </validation-provider>

        <validation-provider name="categoryName" rules="required" v-slot="{ errors, failed }" slim>
          <div class="flex flex-col mx-2">
            <bds-label :text="$t('lists.language.english')" :mandatory="failed"/>
            <div class="flex flex-row">
              <i class="mr-2 flag-icon flag-icon-us"/>
              <vs-input size="small" class="md-base" v-model="category.en.name" :disabled="!edit"/>
            </div>
            <bds-error :text_error="errors[0]"/>
          </div>
        </validation-provider>

        <validation-provider name="categoryName" rules="required" v-slot="{ errors, failed }" slim>
          <div class="flex flex-col mx-2">
            <bds-label :text="$t('lists.language.spanish')" :mandatory="failed"/>
            <div class="flex flex-row">
              <i class="mr-2 flag-icon flag-icon-es"/>
              <vs-input size="small" class="md-base" v-model="category.es.name" :disabled="!edit"/>
            </div>
            <bds-error :text_error="errors[0]"/>
          </div>
        </validation-provider>

        <div class="flex flex-row">
          <feather-icon icon="EditIcon" svgClasses="hover:text-primary stroke-current m-2" v-if="!edit" @click="edit=true"/>
          <feather-icon icon="XCircleIcon" svgClasses="hover:text-primary stroke-current m-2" v-if="edit" @click="reset"/>
          <feather-icon icon="CheckSquareIcon" svgClasses="hover:text-primary stroke-current m-2" :disabled="!valid" v-if="edit" @click="saveCategory"/>
        </div>
      </div>
    </validation-observer>
  </vx-card>
</template>

<script>
import ProductCategoryService from "@/services/ProductCategory.service";
import {ProductCategory} from "@/models/ProductCategory.model";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  name: 'product-category-item',
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    dataParam: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      category: null,
      edit: false,
      loaded: false
    }
  },
  computed: {

  },
  methods: {
    initValues() {
      if (this.dataParam == null) {
        this.category = new ProductCategory();
      } else {
        this.category = ProductCategory.FromObj(this.dataParam);
      }
    },
    reset() {
      this.initValues();
      this.edit = false;
    },
    saveCategory() {
      this.$refs.productCategoryForm.validate().then((result) => {
        if (!result) {
          return;
        }

        ProductCategoryService.updateCategory(this.category).then((response) => {
          this.$store.dispatch('ProductCategory/updateCategory', response).then(() => {
            this.reset();
          });
        });
      });
    }
  },
  created() {
    this.loaded = false;
  },
  mounted: function() {
    this.category = ProductCategory.FromObj(this.dataParam);
    this.loaded = true;
  },
}
</script>

<style scoped>

</style>
